'use strict'

import angular from 'angular'

angular.module('core.buysheetlineitemfield.services', [])
    .factory('BuySheetLineItemFieldFactory', BuySheetLineItemFieldFactory)

/**
 * @ngInject
 */
function BuySheetLineItemFieldFactory(
    Restangular,
    ColumnValueType
) {
    var buySheetLineItemFields = Restangular.all('buysheetlineitemfields')
    var vars = buySheetLineItemFields.one('vars')
    var values = buySheetLineItemFields.one('values')

    /**
     *
     * @param queryParams
     * @returns {*|ICollectionPromise<T>|ICollectionPromise<any>|{method, params, headers}}
     */
    function getColumns(queryParams) {
        return buySheetLineItemFields.getList(_.extend({
            metadata: true,
            sort: 'label'
        }, queryParams));
    }

    /**
     * Get all selectable values for specific fields (enum values)
     * @param fields (fields can be undefined to fetch all)
     * @returns {*}
     */
    function getColumnValues(fields) {
        return values.one(ColumnValueType.SET).get(_.isUndefined(fields) ? '' : {fields: fields});
    }

    /**
     * Get all distinct values for specific fields
     * @param fields (fields can be undefined to fetch all)
     * @dataSource unused
     * @queryParams any additional query params
     * @returns {*}
     */
    function getFieldValues(fields, dataSource, queryParams) {
        return values.one(ColumnValueType.DISTINCT).get(
            _.extend(_.isUndefined(fields) ? {} : {fields: fields}, queryParams || {}));
    }

    /**
     * Get data for this resource
     * @param queryParams
     * @returns {*|ICollectionPromise<any>|ICollectionPromise<T>|{method, params, headers}}
     */
    function getData(queryParams) {
        return buySheetLineItemFields.getList(queryParams);
    }

    return {
        ecTasksSummary: buySheetLineItemFields,
        vars: vars,
        getColumns: getColumns,
        getColumnValues: getColumnValues,
        getFieldValues: getFieldValues,
        getData: getData
    }
}